import React, { useEffect, useState } from 'react';
import { Box, FlexControlledForm } from '@common-fe/common-fe';
import { uniqueId } from 'lodash';
import styled from 'styled-components';

import { useCardSetupForm } from '@/modules/employer/components/SetupEmployer/Cards/CardSetup/hooks/useCardSetupForm';
import usePendingDocsEscalationFields from '@/modules/employer/components/SetupEmployer/Cards/CardSetup/hooks/usePendingDocsEscalationFields';
import ToEditButton from '@/modules/employer/components/SetupEmployer/components/ToEditButton';
import { useSetupEmployerMode } from '@/modules/employer/components/SetupEmployer/hooks/useSetupEmployerMode';
import { useSaveTypeStore } from '@/modules/employer/components/SetupEmployer/stores';
import useGetEmployer from '@/modules/employer/hooks/useGetEmployer.query';
import { useStore } from '@/modules/employer/store/useSetupEmployer.store';
import { useIsCardClaimSuspensionAvailable } from '@/modules/featureFlags';
import theme from '@/styles/theme';

interface Props {
  disabled?: boolean;
  onDirty?: (isDirty: boolean) => void;
}

// Grommet's Radio subFields wrapper (className "labeless") hardcodes margin-top to
// the "m" (16px) spacing token; Figma calls for 8px here between "Yes" and the input.
const PendingDocsEscalationBox = styled(Box)`
  .labeless {
    margin-top: ${theme.spacings.spacing8} !important;
  }
`;

const CardSetup: React.FC<Props> = ({ disabled, onDirty }) => {
  const [formKey, setFormKey] = useState('');
  const { viewMode } = useSetupEmployerMode();
  const { activeStatus, activateSubmitted } = useSaveTypeStore();
  const fields = useCardSetupForm(activateSubmitted, formKey);
  const pendingDocsEscalationFields = usePendingDocsEscalationFields();
  const isCardClaimSuspensionAvailable = useIsCardClaimSuspensionAvailable();
  const cardOffered = useStore((state) => state.cardsSetup?.cardOffered);
  const { formattedData } = useGetEmployer();
  const isPendingDocsEscalationEditMode = !viewMode && !disabled;
  useEffect(() => {
    setFormKey(uniqueId());
  }, [formattedData]);

  return (
    <div id="cards_section">
      <Box background="canvas" round="container1Round">
        <FlexControlledForm
          key={formKey}
          editMode={!viewMode && !disabled}
          formTitle="Cards"
          showError={activeStatus}
          fields={fields}
          onChangeValues={() => {}}
          onDirty={onDirty}
          isThinMode
        >
          {disabled ? null : <ToEditButton />}
        </FlexControlledForm>
      </Box>
      {isCardClaimSuspensionAvailable && cardOffered && (
        <PendingDocsEscalationBox
          background="canvas"
          round="container1Round"
          margin={{ top: 'spacing24' }}
          id="pending_docs_escalation"
        >
          <FlexControlledForm
            key={`pending-docs-escalation-${formKey}`}
            editMode={isPendingDocsEscalationEditMode}
            formTitle="Pending Docs Escalation"
            showError={activeStatus}
            fields={pendingDocsEscalationFields}
            onChangeValues={() => {}}
            onDirty={onDirty}
            isThinMode
          />
        </PendingDocsEscalationBox>
      )}
    </div>
  );
};

export default CardSetup;
